import { z } from "zod";
export const ZMcappsPnsNodeProps = z.object({
    pnsId: z.string().min(1),
    title: z.string().min(1),
});
export const ZMcappsPnsNode = z.object({
    _id: z.string().min(1),
    parentId: z.string().min(1).nullable(),
    props: ZMcappsPnsNodeProps,
});
export const ZMcappsPnsList = z.array(ZMcappsPnsNode);
